import { connect } from 'react-redux';

import ManifestShipmentComponent from './shipment-manifest.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ManifestShipmentComponent);



// WEBPACK FOOTER //
// ./src/components/admin/manifest/shipment-manifest.ts